// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadTranslations as loadTranslationsApPricing } from '@admin-panel/ap-pricing'
import { loadTranslations as loadTranslationsApServiceSettings } from '@admin-panel/ap-service-settings'
import { loadTranslations as loadTranslationsCampaignBuilder } from '@admin-panel/campaign-builder'
import { loadTranslations as loadTranslationsFleetPlanner } from '@admin-panel/fleet-planner'
import { loadTranslations as loadTranslationsIncidentAnalysis } from '@admin-panel/incident-analysis'
import { loadTranslations as loadTranslationsSafetyDriverAnnotations } from '@admin-panel/safety-driver-annotations'
import { loadTranslations as loadTranslationsTemporaryBackofficeSessions } from '@admin-panel/temporary-backoffice-sessions'
import { loadTranslations as loadTranslationsUserManagement } from '@admin-panel/user-management'
import { loadTranslations as loadTranslationsVehicleDeviceManagementAdmin } from '@admin-panel/vehicle-device-management-admin'
import { loadTranslations as loadTranslationsVvDavt } from '@admin-panel/vv-davt'
import { loadTranslations as loadTranslationsFleetDashboard } from '@backoffice/fleet-dashboard'
import { loadTranslations as loadTranslationsFleetTracing } from '@backoffice/fleet-tracing'
import { loadTranslations as loadTranslationsInAppMessages } from '@backoffice/in-app-messages'
import { loadTranslations as loadTranslationsRoadNetwork } from '@backoffice/road-network'
import { loadTranslations as loadTranslationsSimManagement } from '@backoffice/sim-management'
import { loadTranslations as loadTranslationsTripApiConfiguration } from '@backoffice/trip-api-configuration'
import { loadTranslations as loadTranslationsUserManagementOrganization } from '@backoffice/user-management-organization'
import { loadTranslations as loadTranslationsVehicleCapacityConfig } from '@backoffice/vehicle-capacity-config'
import { loadTranslations as loadTranslationsVehiclePlans } from '@backoffice/vehicle-plans'
import { loadTranslations as loadTranslationsAccidentsReports } from '@backoffice-frontend/accidents-reports'
import { loadTranslations as loadTranslationsAccounting } from '@backoffice-frontend/accounting'
import { loadTranslations as loadTranslationsAdConfiguration } from '@backoffice-frontend/ad-configuration'
import { loadTranslations as loadTranslationsAdFleetMap } from '@backoffice-frontend/ad-fleet-map'
import { loadTranslations as loadTranslationsAlerts } from '@backoffice-frontend/alerts'
import { loadTranslations as loadTranslationsAppAccessControl } from '@backoffice-frontend/app-access-control'
import { loadTranslations as loadTranslationsCapacityPlanning } from '@backoffice-frontend/capacity-planning'
import { loadTranslations as loadTranslationsCoupon } from '@backoffice-frontend/coupon'
import { loadTranslations as loadTranslationsCustomer } from '@backoffice-frontend/customer'
import { loadTranslations as loadTranslationsCustomerFeatureAllowlisting } from '@backoffice-frontend/customer-feature-allowlisting'
import { loadTranslations as loadTranslationsDemoRoutes } from '@backoffice-frontend/demo-routes'
import { loadTranslations as loadTranslationsDisruptions } from '@backoffice-frontend/disruptions'
import { loadTranslations as loadTranslationsDriverTipping } from '@backoffice-frontend/driver-tipping'
import { loadTranslations as loadTranslationsDsBoss } from '@backoffice-frontend/ds-boss'
import { loadTranslations as loadTranslationsEmployee } from '@backoffice-frontend/employee'
import { loadTranslations as loadTranslationsEmployeeTimeManagement } from '@backoffice-frontend/employee-time-management'
import { loadTranslations as loadTranslationsFleetMaintenance } from '@backoffice-frontend/fleet-maintenance'
import { loadTranslations as loadTranslationsFleetMap } from '@backoffice-frontend/fleet-map'
import { loadTranslations as loadTranslationsFleetPerformanceOverview } from '@backoffice-frontend/fleet-performance-overview'
import { loadTranslations as loadTranslationsFleets } from '@backoffice-frontend/fleets'
import { loadTranslations as loadTranslationsKpiDashboard } from '@backoffice-frontend/kpi-dashboard'
import { loadTranslations as loadTranslationsLegalDocumentManagement } from '@backoffice-frontend/legal-document-management'
import { loadTranslations as loadTranslationsMobileAppFlavorConfig } from '@backoffice-frontend/mobile-app-flavor-config'
import { loadTranslations as loadTranslationsMobileAppstoreAssets } from '@backoffice-frontend/mobile-appstore-assets'
import { loadTranslations as loadTranslationsOfferAndPooling } from '@backoffice-frontend/offer-and-pooling'
import { loadTranslations as loadTranslationsPassengerApp } from '@backoffice-frontend/passenger-app'
import { loadTranslations as loadTranslationsPricing } from '@backoffice-frontend/pricing'
import { loadTranslations as loadTranslationsReportIo } from '@backoffice-frontend/report-io'
import { loadTranslations as loadTranslationsRiderFeedback } from '@backoffice-frontend/rider-feedback'
import { loadTranslations as loadTranslationsSafetyDriverGuidance } from '@backoffice-frontend/safety-driver-guidance'
import { loadTranslations as loadTranslationsServiceBreakLocations } from '@backoffice-frontend/service-break-locations'
import { loadTranslations as loadTranslationsServiceSettings } from '@backoffice-frontend/service-settings'
import { loadTranslations as loadTranslationsShifts } from '@backoffice-frontend/shifts'
import { loadTranslations as loadTranslationsShiftsCreation } from '@backoffice-frontend/shifts-creation'
import { loadTranslations as loadTranslationsStatus } from '@backoffice-frontend/status'
import { loadTranslations as loadTranslationsStopNetwork } from '@backoffice-frontend/stop-network'
import { loadTranslations as loadTranslationsTrip } from '@backoffice-frontend/trip'
import { loadTranslations as loadTranslationsUpdates } from '@backoffice-frontend/updates'
import { loadTranslations as loadTranslationsVehicle } from '@backoffice-frontend/vehicle'
import { loadTranslations as loadTranslationsVehicleAlerts } from '@backoffice-frontend/vehicle-alerts'
import { loadTranslations as loadTranslationsVehicleDeviceManagement } from '@backoffice-frontend/vehicle-device-management'
import { loadTranslations as loadTranslationsWelcome } from '@backoffice-frontend/welcome'
import { loadTranslations as loadTranslationsWelcomeAdminPanel } from '@backoffice-frontend/welcome-admin-panel'

export const loadSharedAreaTranslations = () => {
  loadTranslationsUpdates()
  loadTranslationsStatus()
  loadTranslationsPassengerApp()
  loadTranslationsWelcome()
  loadTranslationsWelcomeAdminPanel()
  loadTranslationsTemporaryBackofficeSessions()
  loadTranslationsUserManagement()
  loadTranslationsCampaignBuilder()
  loadTranslationsVehicleDeviceManagementAdmin()
  loadTranslationsIncidentAnalysis()
  loadTranslationsVvDavt()
  loadTranslationsApServiceSettings()
  loadTranslationsApPricing()
  loadTranslationsFleetPlanner()
  loadTranslationsUserManagementOrganization()
  loadTranslationsFleetMap()
  loadTranslationsAccounting()
  loadTranslationsAdConfiguration()
  loadTranslationsAdFleetMap()
  loadTranslationsSafetyDriverGuidance()
  loadTranslationsAlerts()
  loadTranslationsCoupon()
  loadTranslationsCustomer()
  loadTranslationsKpiDashboard()
  loadTranslationsDriverTipping()
  loadTranslationsEmployee()
  loadTranslationsEmployeeTimeManagement()
  loadTranslationsFleetMaintenance()
  loadTranslationsPricing()
  loadTranslationsShifts()
  loadTranslationsCapacityPlanning()
  loadTranslationsShiftsCreation()
  loadTranslationsStopNetwork()
  loadTranslationsRoadNetwork()
  loadTranslationsServiceBreakLocations()
  loadTranslationsTrip()
  loadTranslationsVehicle()
  loadTranslationsVehicleAlerts()
  loadTranslationsDemoRoutes()
  loadTranslationsDsBoss()
  loadTranslationsOfferAndPooling()
  loadTranslationsServiceSettings()
  loadTranslationsCustomerFeatureAllowlisting()
  loadTranslationsAccidentsReports()
  loadTranslationsReportIo()
  loadTranslationsDisruptions()
  loadTranslationsFleets()
  loadTranslationsLegalDocumentManagement()
  loadTranslationsFleetDashboard()
  loadTranslationsFleetTracing()
  loadTranslationsVehiclePlans()
  loadTranslationsMobileAppstoreAssets()
  loadTranslationsAppAccessControl()
  loadTranslationsVehicleDeviceManagement()
  loadTranslationsSimManagement()
  loadTranslationsRiderFeedback()
  loadTranslationsFleetPerformanceOverview()
  loadTranslationsMobileAppFlavorConfig()
  loadTranslationsInAppMessages()
  loadTranslationsVehicleCapacityConfig()
  loadTranslationsTripApiConfiguration()
  loadTranslationsSafetyDriverAnnotations()
}
